var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_494",
    "data-name": "Grupo 494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_493",
    "data-name": "Grupo 493"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_38",
    "data-name": "Elipse 38",
    cx: 0.938,
    cy: 0.938,
    r: 0.938,
    transform: "translate(17.156 8.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5001",
    "data-name": "Trazado 5001",
    d: "M20.25,1.875H19.031V.938a.938.938,0,0,0-1.875,0v.938H12.891V.938a.938.938,0,0,0-1.875,0v.938H6.8V.938a.937.937,0,1,0-1.875,0v.938H3.75A3.754,3.754,0,0,0,0,5.625V20.25A3.754,3.754,0,0,0,3.75,24h7.172a.938.938,0,0,0,0-1.875H3.75A1.877,1.877,0,0,1,1.875,20.25V5.625A1.877,1.877,0,0,1,3.75,3.75H4.922v.938a.937.937,0,0,0,1.875,0V3.75h4.219v.938a.938.938,0,0,0,1.875,0V3.75h4.266v.938a.938.938,0,0,0,1.875,0V3.75H20.25a1.877,1.877,0,0,1,1.875,1.875v5.344a.938.938,0,0,0,1.875,0V5.625A3.754,3.754,0,0,0,20.25,1.875Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5002",
    "data-name": "Trazado 5002",
    d: "M275.672,270a5.672,5.672,0,1,0,5.672,5.672A5.678,5.678,0,0,0,275.672,270Zm0,9.469a3.8,3.8,0,1,1,3.8-3.8A3.8,3.8,0,0,1,275.672,279.469Z",
    transform: "translate(-257.344 -257.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5003",
    "data-name": "Trazado 5003",
    d: "M373.3,331.922h-.422v-.984a.938.938,0,0,0-1.875,0v1.922a.937.937,0,0,0,.938.938H373.3a.938.938,0,0,0,0-1.875Z",
    transform: "translate(-353.609 -314.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_39",
    "data-name": "Elipse 39",
    cx: 0.938,
    cy: 0.938,
    r: 0.938,
    transform: "translate(13.078 8.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_40",
    "data-name": "Elipse 40",
    cx: 0.938,
    cy: 0.938,
    r: 0.938,
    transform: "translate(9 12.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_41",
    "data-name": "Elipse 41",
    cx: 0.938,
    cy: 0.938,
    r: 0.938,
    transform: "translate(4.922 8.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_42",
    "data-name": "Elipse 42",
    cx: 0.938,
    cy: 0.938,
    r: 0.938,
    transform: "translate(4.922 12.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_43",
    "data-name": "Elipse 43",
    cx: 0.938,
    cy: 0.938,
    r: 0.938,
    transform: "translate(4.922 17.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_44",
    "data-name": "Elipse 44",
    cx: 0.938,
    cy: 0.938,
    r: 0.938,
    transform: "translate(9 17.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_45",
    "data-name": "Elipse 45",
    cx: 0.938,
    cy: 0.938,
    r: 0.938,
    transform: "translate(9 8.906)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.563fbd3a67fd30b63561d124c3d9287d.svg";
export { ForwardRef as ReactComponent };